// noinspection DuplicatedCode

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit,
  faMagnifyingGlassPlus,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { ModalDialog } from 'components/ModalDialog/ModalDialog';
import BlockParameterEditor from './BlockParameterEditor';
import UseItemInformation from './useItemInformation';

const propTypes = {
  partnerId: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  onSubmit: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.object,
};
const defaultProps = {
  onCancel: () => null,
  onSubmit: () => null,
  item: {
    data: [
      {
        dataKey: 'item_guid',
        value: null,
        groupKey: 'items',
      },
    ],
  },
};

export default function ItemBlockItemInformation(props) {
  console.log(props);
  const { item, onCancel, partnerId } = props;
  const [open, setOpen] = useState(false);
  const [itemParam, setItemParam] = useState('');
  const {
    medias,
    setMedias,
    isLoading,
    itemInformation,
    setItemInformation,
    isShowItemMediaForm,
    selectedMedia,
    mutationGetMedias,
    onItemParameterEditorSubmit,
    showMediaFormEditor,
    onMediaParameterEditorCancel,
    onMediaParameterEditorSubmit,
    editMedia,
    deleteMedia,
    mediaTypeText,
  } = UseItemInformation(props);
  useEffect(() => {
    setMedias([]);
    if (item.data && item.data.length > 0 && item.data[0].value) {
      setItemInformation(item.data[0].value);
      mutationGetMedias.mutate(item.data[0].value.id);
    }
  }, [item]);

  const onDelete = (id) => {
    setOpen(true);
    setItemParam(id);
  };

  const onDeleteConfirm = () => {
    deleteMedia(itemParam);
    setOpen(false);
  };

  return (
    <div
      className="item-block-item-information shadow-lg"
      data-testid="Wrapper-itemTable"
    >
      <div className="bg-light border p-3 mb-3">
        <BlockParameterEditor
          partnerId={partnerId}
          title="Item Information"
          disabled={isLoading}
          media={item}
          onSubmit={onItemParameterEditorSubmit}
          onCancel={onCancel}
        />
      </div>
      {itemInformation?.id?.length > 0 && (
        <div className="item-media">
          <div className="d-flex align-content-center align-items-center">
            <div className="d-block flex-grow-1">
              <h4 className="p-0 m-0">Item Media</h4>
            </div>
            <div className="d-block">
              <Button
                type="button"
                className="mt-2 btn btn-primary btn-sm btn-pmi"
                onClick={showMediaFormEditor}
              >
                Add Media
              </Button>
            </div>
          </div>
          <hr />
          <div className="table-responsive">
            <Table bordered striped>
              <thead>
                <tr>
                  <th>Order</th>
                  <th>Item Title</th>
                  <th>Description</th>
                  <th>Media</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {medias.length > 0 &&
                  medias.map((m, i) => (
                    <tr key={`media-${i.toString()}`}>
                      <td>{m.displayOrder}</td>
                      <td>{m.title}</td>
                      <td>{m.description}</td>
                      <td>{mediaTypeText(m.mediaType)}</td>
                      <td>
                        <Button variant="link" size="sm" className="p-1">
                          <FontAwesomeIcon
                            icon={faEdit}
                            onClick={() => editMedia(m)}
                          />
                        </Button>
                        <Button variant="link" size="sm" className="p-1">
                          <FontAwesomeIcon
                            icon={faTrashAlt}
                            onClick={() => onDelete(m.id)}
                          />
                        </Button>
                        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                        <a
                          href={m.mediaPath}
                          target="_blank"
                          className="btn btn-sm btn-link p-1"
                          rel="noreferrer"
                        >
                          <FontAwesomeIcon icon={faMagnifyingGlassPlus} />
                        </a>
                      </td>
                    </tr>
                  ))}
                {medias.length === 0 && !mutationGetMedias.isLoading && (
                  <tr>
                    <td colSpan="5">
                      <p
                        className="p-0 m-0 text-muted text-center"
                        data-testid="Text-noItems"
                      >
                        No items added.
                      </p>
                    </td>
                  </tr>
                )}
                {mutationGetMedias.isLoading && (
                  <tr>
                    <td colSpan="5">
                      <p className="p-0 m-0 text-muted text-center">
                        Loading...
                      </p>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      )}
      {isShowItemMediaForm && (
        <div className="item-media-overlay">
          <div className="shadow-lg">
            <BlockParameterEditor
              partnerId={partnerId}
              disabled={isLoading}
              media={selectedMedia}
              onSubmit={onMediaParameterEditorSubmit}
              onCancel={onMediaParameterEditorCancel}
            />
          </div>
        </div>
      )}
      <ModalDialog
        open={open}
        setOpen={setOpen}
        header="Delete Item"
        message="You are about to delete an item. Are you sure about it?"
        onConfirm={onDeleteConfirm}
      />
    </div>
  );
}

ItemBlockItemInformation.propTypes = propTypes;
ItemBlockItemInformation.defaultProps = defaultProps;
